import { RequireAuth, RequireGroup } from "@allergy123/auth-client/react";
import { createBrowserRouter, Outlet } from "react-router";
import { AdminShell } from "./shell";
import { AuditPage } from "./pages/Audit";
import { AuthCallbackPage, NoAccessPage, SignedOutPage } from "./pages/auth";
import { AntigenPage } from "./pages/catalog/Antigen";
import { AntigensPage } from "./pages/catalog/Antigens";
import { PanelComparePage } from "./pages/catalog/PanelCompare";
import { PanelsPage } from "./pages/catalog/Panels";
import { PanelVersionPage } from "./pages/catalog/PanelVersion";
import { ProductPage } from "./pages/catalog/Product";
import { ProductsPage } from "./pages/catalog/Products";
import { ProfileComparePage } from "./pages/catalog/ProfileCompare";
import { ProfilesPage } from "./pages/catalog/Profiles";
import { ProfileVersionPage } from "./pages/catalog/ProfileVersion";
import { RecipesPage } from "./pages/catalog/Recipes";
import { RegionDefaultsPage } from "./pages/catalog/RegionDefaults";
import { InvitePage } from "./pages/Invite";
import { LearnerPage } from "./pages/Learner";
import { LearnersPage } from "./pages/Learners";
import { OrdersPage } from "./pages/Orders";
import { OrganizationBillingPage } from "./pages/OrganizationBilling";
import { OrganizationLocationsPage } from "./pages/OrganizationLocations";
import { OrganizationMembersPage } from "./pages/OrganizationMembers";
import { OrganizationsPage } from "./pages/Organizations";
import { SecurityPage } from "./pages/Security";

/**
 * Staff console (ADR 0011). The browser gate on the platform-admin group only
 * avoids rendering screens a user cannot use; the API makes the real decision,
 * including the MFA requirement, on every admin route.
 */
export const router = createBrowserRouter([
  { path: "/auth/callback", Component: AuthCallbackPage },
  { path: "/auth/signed-out", Component: SignedOutPage },
  { path: "/no-access", Component: NoAccessPage },
  {
    path: "/",
    element: (
      <RequireAuth fallback={<p className="p-6 text-ink-secondary">Signing you in…</p>}>
        <RequireGroup group="platform-admin" denied={<NoAccessPage />}>
          <AdminShell>
            <Outlet />
          </AdminShell>
        </RequireGroup>
      </RequireAuth>
    ),
    children: [
      { index: true, Component: OrganizationsPage },
      { path: "organizations", Component: OrganizationsPage },
      { path: "organizations/:id/locations", Component: OrganizationLocationsPage },
      { path: "organizations/:id/members", Component: OrganizationMembersPage },
      { path: "organizations/:id/billing", Component: OrganizationBillingPage },
      { path: "orders", Component: OrdersPage },
      { path: "learners", Component: LearnersPage },
      { path: "learners/:id", Component: LearnerPage },
      { path: "invite", Component: InvitePage },
      { path: "audit", Component: AuditPage },
      { path: "security", Component: SecurityPage },
      { path: "catalog/antigens", Component: AntigensPage },
      { path: "catalog/antigens/:id", Component: AntigenPage },
      { path: "catalog/products", Component: ProductsPage },
      { path: "catalog/products/:id", Component: ProductPage },
      { path: "catalog/recipes", Component: RecipesPage },
      { path: "catalog/panels", Component: PanelsPage },
      { path: "catalog/panels/versions/:id", Component: PanelVersionPage },
      { path: "catalog/panels/compare", Component: PanelComparePage },
      { path: "catalog/profiles", Component: ProfilesPage },
      { path: "catalog/profiles/versions/:id", Component: ProfileVersionPage },
      { path: "catalog/profiles/compare", Component: ProfileComparePage },
      { path: "catalog/region-defaults", Component: RegionDefaultsPage },
    ],
  },
]);
